import { ISharedShiftSlot } from "@src/app/dayView/constants";
import { Dispatch } from "redux";

import { ActionType } from "./model";

const setShowToast =
  (toastName = "") =>
  (dispatch: Dispatch) => {
    dispatch({
      type: ActionType.SET_SHOW_TOAST,
      data: { showToast: toastName },
    });
  };

const updateSharedShiftSlot = (sharedShiftSlot: ISharedShiftSlot | null) => ({
  type: ActionType.UPDATE_SHARED_SHIFT_SLOT,
  data: {
    sharedShiftSlot,
  },
});

export { setShowToast, updateSharedShiftSlot };
